export const REFERRAL_BANNER_CONSTANTS = {
  TITLE: "Turn your network into income",
  DESCRIPTION:
    "Earn FLAT 25% commission on referrals. Help the right people discover Exly. Share what works, support their growth, and earn from your referrals.",
  BUTTON_TEXT: "How it works",
  CREATOR_STORIES_BUTTON_TEXT: "See creator stories",
  CREATOR_STORIES_TARGET_ID: "creator-stories-section",
  TARGET_SECTION_ID: "referral-how-it-works-section",
  COMMISSION_CARD: {
    LABEL: "Commission credited",
    AMOUNT: "+₹7,500",
    PLAN: "Pro Plan",
    CYCLE: "Annual",
    CURRENCY_SYMBOL: "₹",
  },
  FRIENDS_CARD: {
    DEFAULT_RATE: 25,
    PERCENT_SYMBOL: "%",
    SINGULAR_TEXT: "friend joined with your link",
    PLURAL_TEXT: "friends joined with your link",
    COLOR_PALETTES: [
      "tw-bg-[#F6C343] tw-text-[#784D00]",
      "tw-bg-[#ADC8FF] tw-text-[#1D39C4]",
      "tw-bg-[#95F5C3] tw-text-[#086337]",
      "tw-bg-[#FFD6E7] tw-text-[#C41D7F]",
      "tw-bg-[#D3ADF7] tw-text-[#531DAB]",
    ],
    MAX_VISIBLE_AVATARS: 3,
    FALLBACK_INITIALS: ["AM", "PN", "RK"],
    FALLBACK_INITIAL: "EX",
    CONVERTED_STATUS: 1,
    SINGLE_FRIEND_COUNT: 1,
    START_INDEX: 0,
    TWO_PARTS_LENGTH: 2,
  },
};
